import { articles, categories, type Article, type Category } from '@/mocks/articles';

export function getCategoryByKey(key: string): Category | undefined {
  return categories.find((item) => item.key === key);
}

export function getCategoryName(key: string): string {
  return getCategoryByKey(key)?.name ?? '未分类';
}

export function getArticlesByCategory(key: string): Article[] {
  return articles.filter((item) => item.category === key);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((item) => item.id === id);
}

export function getLatestArticles(count: number): Article[] {
  return [...articles].sort((a, b) => b.date.localeCompare(a.date)).slice(0, count);
}

export function getHotArticles(count: number): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, count);
}

export function getRelatedArticles(article: Article, count: number): Article[] {
  const sameCategory = articles.filter(
    (item) => item.category === article.category && item.id !== article.id,
  );
  if (sameCategory.length >= count) {
    return sameCategory.slice(0, count);
  }
  const fillers = getHotArticles(count * 2).filter(
    (item) => item.id !== article.id && !sameCategory.some((s) => s.id === item.id),
  );
  return [...sameCategory, ...fillers].slice(0, count);
}

export function searchArticles(keyword: string): Article[] {
  const term = keyword.trim().toLowerCase();
  if (!term) return [];
  return articles.filter((item) => {
    const haystack = [
      item.title,
      item.summary,
      item.author,
      getCategoryName(item.category),
      ...item.tags,
      ...item.content.map((block) => block.text ?? ''),
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(term);
  });
}

export function formatDate(date: string): string {
  const [year, month, day] = date.split('-');
  if (!year || !month || !day) return date;
  return `${year}年${month}月${day}日`;
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export const allTags: string[] = Array.from(
  new Set(articles.flatMap((item) => item.tags)),
);